import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import New from '../views/New.vue'
import newDirectionsDetail from '../views/newDirectionsDetail.vue'
import newVideoDetail from '../views/newVideoDetail.vue'
import secondary from '../views/secondary.vue'
import fullyGood from '../views/fullyGood.vue'
import search from '../views/search.vue'
import twolevel from '../views/twoLevel.vue'
import newDetailList from '../views/newDetailList.vue'
import lbSecondary from '../views/lbSecondary.vue'
import lbFullyGood from '../views/lbFullyGood.vue'
import lbSearch from '../views/lbSearch.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/download'),
    meta: {
      title: '联吧调试说明'
    }
  },
  {
    path: '/useVideo',
    name: 'useVideo',
    component: () => import('../views/useVideo'),
    meta: {
      title: '使用视频'
    }
  },
  {
    path: '/useDirection',
    name: 'useDirection',
    component: () => import('../views/useDirection'),
    meta: {
      title: '使用说明'
    }
  },
  {
    path: '/productIndex',
    name: 'productIndex',
    component: () => import('../views/productIndex'),
    meta: {
      title: '产品介绍'
    }
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: () => import('../views/productDetail'),
    meta: {
      title: '产品描述'
    }
  },
  {
    path: '/productDirection',
    name: 'productDirection',
    component: () => import('../views/productDirection'),
    meta: {
      title: '安麟产品说明'
    }
  },
  {
    path: '/videoDetail',
    name: 'videoDetail',
    component: () => import('../views/videoDetail'),
    meta: {
      title: '视频说明'
    }
  },
  {
    path: '/directionsDetail',
    name: 'directionsDetail',
    component: () => import('../views/directionsDetail'),
    meta: {
      title: '图文说明'
    }
  },
  {
    path: '/New',
    component: New,
    name: 'New'
  },
  {
    path: '/newDirectionsDetail',
    component: newDirectionsDetail,
    name: 'newDirectionsDetail'
  },
  {
    path: '/newVideoDetail',
    component: newVideoDetail,
    name: 'newVideoDetail'
  },
  {
    path: '/secondary',
    component: secondary,
    name: 'secondary'
  },
  {
    path: '/fullyGood',
    component: fullyGood,
    name: 'fullyGood'
  },
  {
    path: '/search',
    component: search,
    name: 'search',
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/twolevel',
    component: twolevel,
    name: 'twolevel'
  },
  {
    path: '/newDetailList',
    component: newDetailList,
    name: 'newDetailList'
  },
  {
    path: '/lbSecondary',
    component: lbSecondary,
    name: 'lbSecondary'
  },
  {
    path: '/lbFullyGood',
    component: lbFullyGood,
    name: 'lbFullyGood'
  },
  {
    path: '/lbSearch',
    component: lbSearch,
    name: 'lbSearch',
    meta: {
      keepAlive: true,
      isUseCache: false
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
